class BarikiShell {
  constructor() {
    this.menuRoot = document.querySelector('[data-menu-root]');
    this.menuToggleButton = document.querySelector('[data-menu-toggle]');
    this.menuToggle = this.menuToggleButton?.closest('.mega-menu-toggle') || this.menuToggleButton;
    this.menuClose = document.querySelector('[data-menu-close]');
    this.menuList = document.querySelector('#mega-menu-primary');
    this.mobileMenuLinks = document.querySelectorAll('#mega-menu-primary .mega-menu-item-has-children > .mega-menu-link');
    this.searchButton = document.querySelector('[data-search-toggle]');
    this.searchForm = document.querySelector('[data-search-form]');

    if (this.menuToggleButton) {
      this.menuToggleButton.addEventListener('click', () => {
        if (this.isMenuOpen()) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      });
    }

    if (this.menuClose) {
      this.menuClose.addEventListener('click', () => this.closeMenu());
    }

    if (this.searchButton && this.searchForm) {
      this.searchButton.addEventListener('click', () => this.toggleSearch());
    }

    this.mobileMenuLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (window.innerWidth > 992) return;
        event.preventDefault();
        const item = link.closest('.mega-menu-item');
        if (!item) return;

        if (!item.classList.contains('mega-toggle-on')) {
          this.closeSiblingSubmenus(item);
          item.classList.add('mega-toggle-on');
          link.setAttribute('aria-expanded', 'true');
        } else {
          item.classList.remove('mega-toggle-on');
          link.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.isMenuOpen() || window.innerWidth > 992) return;
      if (this.menuRoot?.contains(event.target)) return;
      this.closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeMenu();
      }
    });

    document.querySelectorAll('[data-accordion-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const item = button.closest('.accordion-item');
        const panel = item?.querySelector('.accordion-collapse');
        if (!item || !panel) return;

        const isOpen = item.classList.contains('is-open');
        const icon = button.querySelector('.accordion-icon');
        const isMobile = window.innerWidth <= 768;
        const buttonTopBefore = button.getBoundingClientRect().top;

        if (isOpen) {
          // Collapse: set explicit height then transition to 0
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
          });
          item.classList.remove('is-open');
          button.classList.add('collapsed');
          button.setAttribute('aria-expanded', 'false');
          if (icon) icon.textContent = '+';
          panel.addEventListener('transitionend', function handler() {
            panel.hidden = true;
            panel.removeEventListener('transitionend', handler);
          }, { once: true });
        } else {
          // Expand: remove hidden, measure, animate from 0
          panel.hidden = false;
          panel.style.maxHeight = '0px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          item.classList.add('is-open');
          button.classList.remove('collapsed');
          button.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '–';
          panel.addEventListener('transitionend', function handler() {
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', handler);
            // Mobile bug fix: keep the accordion button pinned where the user
            // tapped it. Expanding a panel can reflow content above the button
            // (or trigger scroll anchoring), which previously dumped the user
            // down at the related-products section. Compensate by exactly the
            // amount the button moved instead of calling scrollIntoView --
            // scrollIntoView re-scrolls the page itself and caused the jump.
            if (isMobile) {
              const delta = button.getBoundingClientRect().top - buttonTopBefore;
              if (Math.abs(delta) > 1) {
                window.scrollBy(0, delta);
              }
            }
          }, { once: true });
        }
      });
    });

    // Initialize open accordion panels
    document.querySelectorAll('.accordion-item.is-open .accordion-collapse').forEach((panel) => {
      panel.style.maxHeight = 'none';
      const icon = panel.closest('.accordion-item')?.querySelector('.accordion-icon');
      if (icon) icon.textContent = '–';
    });

    document.querySelectorAll('[data-collection-toolbar]').forEach((form) => {
      const filterToggle = form.querySelector('[data-filter-toggle]');
      const filterPills = form.querySelector('[data-filter-pills]');
      const sortInput = form.querySelector('[data-sort-input]');
      const sortLabel = form.querySelector('[data-sort-label]');

      const dropdowns = Array.from(form.querySelectorAll('[data-dd]'));
      const triggers = Array.from(form.querySelectorAll('[data-sort-trigger], [data-pill-trigger]'));

      const closeAllDropdowns = (except) => {
        dropdowns.forEach((dd) => {
          if (dd === except) return;
          dd.hidden = true;
        });
        triggers.forEach((tr) => {
          const ctrl = tr.getAttribute('aria-controls');
          if (ctrl && document.getElementById(ctrl) === except) return;
          tr.setAttribute('aria-expanded', 'false');
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          if (event.target.closest('[data-category-clear]')) return;
          event.stopPropagation();
          const targetId = trigger.getAttribute('aria-controls');
          const target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;
          const willOpen = target.hidden;
          closeAllDropdowns(willOpen ? target : null);
          target.hidden = !willOpen;
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });

      if (filterToggle && filterPills) {
        filterToggle.addEventListener('click', (event) => {
          event.stopPropagation();
          const expanded = filterToggle.getAttribute('aria-expanded') === 'true';
          const willExpand = !expanded;
          filterToggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
          filterPills.hidden = !willExpand;
          if (!willExpand) closeAllDropdowns(null);
        });
      }

      form.querySelectorAll('[data-sort-value]').forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const value = item.dataset.sortValue;
          const text = item.dataset.sortText;
          if (sortInput) sortInput.value = value;
          if (sortLabel && text) sortLabel.textContent = text.toUpperCase();
          form.querySelectorAll('[data-sort-value]').forEach((el) => el.classList.remove('is-active'));
          item.classList.add('is-active');
          form.submit();
        });
      });

      form.querySelectorAll('[data-category-url]').forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const target = item.dataset.categoryUrl;
          if (!target) return;
          const params = new URLSearchParams();
          if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);
          const min = form.querySelector('[data-price-min]');
          const max = form.querySelector('[data-price-max]');
          if (min && min.value) params.set(min.name, min.value);
          if (max && max.value) params.set(max.name, max.value);
          const qs = params.toString();
          window.location.href = qs ? target + '?' + qs : target;
        });
      });

      const slider = form.querySelector('[data-price-slider]');
      const minInput = form.querySelector('[data-price-min]');
      const maxInput = form.querySelector('[data-price-max]');
      const range = form.querySelector('[data-price-range]');
      const thumbMin = form.querySelector('[data-price-thumb-min]');
      const thumbMax = form.querySelector('[data-price-thumb-max]');

      if (slider && minInput && maxInput && range && thumbMin && thumbMax) {
        const cap = Number(slider.dataset.priceMaxCap) || 10000;
        const clampPair = () => {
          let mn = Number(minInput.value || 0);
          let mx = Number(maxInput.value || cap);
          if (mn < 0) mn = 0;
          if (mx > cap) mx = cap;
          if (mn > mx) mn = mx;
          const minPct = (mn / cap) * 100;
          const maxPct = (mx / cap) * 100;
          thumbMin.style.left = minPct + '%';
          thumbMax.style.left = maxPct + '%';
          range.style.left = minPct + '%';
          range.style.right = (100 - maxPct) + '%';
        };

        clampPair();
        minInput.addEventListener('input', clampPair);
        maxInput.addEventListener('input', clampPair);

        const dragThumb = (thumb, isMin) => {
          let dragging = false;
          const move = (clientX) => {
            const rect = slider.getBoundingClientRect();
            const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
            const value = Math.round(pct * cap);
            if (isMin) {
              minInput.value = String(Math.min(value, Number(maxInput.value || cap)));
            } else {
              maxInput.value = String(Math.max(value, Number(minInput.value || 0)));
            }
            clampPair();
          };
          thumb.addEventListener('pointerdown', (e) => {
            dragging = true;
            thumb.setPointerCapture?.(e.pointerId);
            e.preventDefault();
          });
          thumb.addEventListener('pointermove', (e) => {
            if (!dragging) return;
            move(e.clientX);
          });
          const stop = (e) => {
            if (!dragging) return;
            dragging = false;
            try { thumb.releasePointerCapture?.(e.pointerId); } catch (_) {}
          };
          thumb.addEventListener('pointerup', stop);
          thumb.addEventListener('pointercancel', stop);
        };

        dragThumb(thumbMin, true);
        dragThumb(thumbMax, false);
      }

      form.addEventListener('click', (event) => {
        if (event.target.closest('[data-dd]')) event.stopPropagation();
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-collection-toolbar]')) return;
      document.querySelectorAll('[data-collection-toolbar] [data-dd]').forEach((dd) => {
        dd.hidden = true;
      });
      document.querySelectorAll('[data-collection-toolbar] [data-sort-trigger], [data-collection-toolbar] [data-pill-trigger]').forEach((tr) => {
        tr.setAttribute('aria-expanded', 'false');
      });
    });

    document.querySelectorAll('[data-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement?.querySelector('input[type="number"]');
        if (!input) return;
        const step = Number(button.dataset.qtyChange || 0);
        const currentValue = Number(input.value || 1);
        input.value = String(Math.max(1, currentValue + step));
      });
    });

    // Artisans video: pure decorative autoplay (muted + looping via HTML
    // attributes), no UI controls. Nothing to wire up here.

    document.querySelectorAll('[data-enquiry-button]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const contactUrl = document.body.dataset.contactPageUrl || '/contact-us/';
        const url = new URL(contactUrl, window.location.origin);
        url.searchParams.set('source', 'product');
        url.searchParams.set('product', button.dataset.productHandle || '');
        url.searchParams.set('title', button.dataset.productTitle || '');
        window.location.href = url.toString();
      });
    });

    const sortSelect = document.querySelector('[data-sort-products]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const productList = document.querySelector('ul.products.columns-4');
        if (!productList) return;
        const items = Array.from(productList.querySelectorAll(':scope > li.product'));
        items.sort((a, b) => {
          const priceA = parseFloat(a.dataset.price || '0');
          const priceB = parseFloat(b.dataset.price || '0');
          const dateA = a.dataset.date || '';
          const dateB = b.dataset.date || '';
          const orderA = parseInt(a.dataset.order || '0', 10);
          const orderB = parseInt(b.dataset.order || '0', 10);
          switch (sortSelect.value) {
            case 'price-asc': return priceA - priceB;
            case 'price-desc': return priceB - priceA;
            case 'latest': return dateB.localeCompare(dateA);
            case 'popularity': return orderA - orderB;
            default: return orderA - orderB;
          }
        });
        items.forEach((item) => productList.appendChild(item));
      });
    }

    const priceMin = document.querySelector('[data-price-min]');
    const priceMax = document.querySelector('[data-price-max]');
    if (priceMin && priceMax) {
      const applyPriceFilter = () => {
        const min = parseFloat(priceMin.value) || 0;
        const max = parseFloat(priceMax.value) || Infinity;
        const productList = document.querySelector('ul.products.columns-4');
        if (!productList) return;
        productList.querySelectorAll(':scope > li.product').forEach((item) => {
          const price = parseFloat(item.dataset.price || '0');
          item.style.display = (price >= min && price <= max) ? '' : 'none';
        });
      };
      priceMin.addEventListener('change', applyPriceFilter);
      priceMax.addEventListener('change', applyPriceFilter);
    }
  }

  isMenuOpen() {
    return this.menuToggle?.classList.contains('mega-menu-open');
  }

  openMenu() {
    if (!this.menuToggle) return;
    this._savedScrollY = window.scrollY;
    this.menuToggle.classList.add('mega-menu-open');
    this.menuToggleButton?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mega-menu-primary-off-canvas-open');
    document.body.style.top = `-${this._savedScrollY}px`;
  }

  closeMenu() {
    if (!this.menuToggle) return;
    this.menuToggle.classList.remove('mega-menu-open');
    this.menuToggleButton?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mega-menu-primary-off-canvas-open');
    document.body.style.top = '';
    window.scrollTo(0, this._savedScrollY || 0);
    this.menuList?.querySelectorAll('.mega-menu-item-has-children.mega-toggle-on').forEach((item) => {
      item.classList.remove('mega-toggle-on');
      item.querySelector('.mega-menu-link')?.setAttribute('aria-expanded', 'false');
    });
  }

  closeSiblingSubmenus(currentItem) {
    const siblings = currentItem.parentElement?.children || [];
    Array.from(siblings).forEach((sibling) => {
      if (!(sibling instanceof HTMLElement) || sibling === currentItem) return;
      sibling.classList.remove('mega-toggle-on');
      sibling.querySelector('.mega-menu-link')?.setAttribute('aria-expanded', 'false');
    });
  }

  toggleSearch() {
    if (!this.searchForm) return;
    const isOpen = document.body.classList.contains('search-open');
    // Visibility now driven entirely by the body class + CSS transition.
    // Clear any legacy inline display so the CSS animation plays.
    if (this.searchForm.style.display) this.searchForm.style.display = '';
    document.body.classList.toggle('search-open', !isOpen);
    if (!isOpen) {
      const input = this.searchForm.querySelector('input[name="q"]') || this.searchForm.querySelector('input[type="text"]');
      // Focus after the slide-in starts so the keyboard / caret feels responsive
      requestAnimationFrame(() => input?.focus());
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new BarikiShell();
  injectEnquiryOnlyProducts();
  bindCartPageDiscount();
  initHeaderHeightSync();
  initNewsletterForm();
  initScrollAutoplayVideos();
});

/**
 * Play section videos when they scroll into view, pause when they leave.
 *
 * The markup carries the `autoplay` attribute, but browsers routinely refuse
 * it (and when they honour it the clip burns bandwidth playing off-screen from
 * page load). Driving playback from an IntersectionObserver gives the intended
 * "starts when you reach the section" behaviour and calls play() explicitly,
 * which is what actually gets it moving without a click.
 */
function initScrollAutoplayVideos() {
  const videos = document.querySelectorAll('video[data-artisan-video], video[data-scroll-autoplay]');
  if (!videos.length) return;

  // Required for programmatic playback to be allowed without a user gesture.
  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
  });

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => video.play().catch(() => {}));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach((video) => observer.observe(video));
}

// Footer newsletter — 4-state UX, no page reload.
//
// Subscribes the email to Klaviyo's newsletter list via the public
// /client/subscriptions/ endpoint. Bypasses Shopify entirely so no shadow
// customer record is created and no "activate your account" email is sent;
// Klaviyo owns the welcome flow. The Public API Key + list ID below are
// intentionally non-secret (Klaviyo's "Public" key is designed for client-side
// use; the list ID is just a list handle).
const KLAVIYO_PUBLIC_API_KEY = 'SjCN34';
const KLAVIYO_NEWSLETTER_LIST_ID = 'RQsvZ4';
const KLAVIYO_API_REVISION = '2024-10-15';

function initNewsletterForm() {
  const wrap = document.querySelector('[data-newsletter]');
  if (!wrap) return;
  const form = wrap.querySelector('form');
  const input = wrap.querySelector('input[type="email"]');
  const message = wrap.querySelector('[data-newsletter-message]');
  if (!form || !input || !message) return;

  const setState = (state, msg) => {
    wrap.classList.remove('is-focus', 'is-success', 'is-error');
    if (state) wrap.classList.add('is-' + state);
    if (msg) {
      message.textContent = msg;
      message.hidden = false;
    } else {
      message.hidden = true;
      message.textContent = '';
    }
  };

  input.addEventListener('focus', () => {
    if (!wrap.classList.contains('is-success') && !wrap.classList.contains('is-error')) {
      wrap.classList.add('is-focus');
    }
  });
  input.addEventListener('blur', () => wrap.classList.remove('is-focus'));
  input.addEventListener('input', () => {
    if (wrap.classList.contains('is-error') || wrap.classList.contains('is-success')) {
      setState(null);
    }
  });

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());

  const subscribeViaKlaviyo = async (email) => {
    const body = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Footer signup',
          profile: {
            data: {
              type: 'profile',
              attributes: { email }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: KLAVIYO_NEWSLETTER_LIST_ID }
          }
        }
      }
    });
    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_API_KEY);
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_API_REVISION,
        'Accept': 'application/json'
      },
      body
    });
    // Klaviyo returns 202 Accepted on success regardless of whether the email
    // was new or already on the list — it's idempotent. Treat any 2xx as
    // success and surface the body only on errors.
    if (res.status >= 200 && res.status < 300) return { ok: true };
    let detail = '';
    try {
      const j = await res.json();
      detail = (j.errors && j.errors[0] && (j.errors[0].detail || j.errors[0].title)) || '';
    } catch (_) {}
    return { ok: false, status: res.status, detail };
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    if (!isValidEmail(email)) {
      setState('error', 'Invalid email');
      input.focus();
      return;
    }
    setState(null);
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const result = await subscribeViaKlaviyo(email);
      if (result.ok) {
        setState('success', 'Thanks — you are subscribed to our newsletter');
        form.reset();
      } else {
        setState('error', result.detail || 'Could not subscribe. Please try again.');
      }
    } catch (err) {
      setState('error', 'Network error. Please retry.');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

}

// Keeps --header-height CSS var in sync with the live rendered header height
// so the fixed-position search overlay always sits flush against the header
// bottom, no gap and no overlap, at any breakpoint.
function initHeaderHeightSync() {
  const header = document.querySelector('header.site-header') || document.querySelector('header');
  if (!header) return;

  // --header-height is consumed by the fixed search overlay's `top:` to sit
  // exactly below the header. So we want the viewport y-coordinate where the
  // header *bottom* sits, NOT just the header element's intrinsic height — the
  // announcement bar above shifts that bottom edge until the user has scrolled
  // past it. Measuring `.bottom` and re-syncing on scroll keeps the overlay
  // pinned correctly at any scroll position.
  const sync = () => {
    const bottom = header.getBoundingClientRect().bottom;
    if (bottom > 0) {
      // Round up so sub-pixel rounding can never under-measure.
      document.documentElement.style.setProperty('--header-height', Math.ceil(bottom) + 'px');
    }
  };

  // Initial pass + repeat after fonts settle
  sync();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sync);
  }
  setTimeout(sync, 250);

  // Live updates as the header geometry changes (resize, font load, etc.)
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(sync).observe(header);
  } else {
    window.addEventListener('resize', sync);
  }

  // The announcement bar above scrolls away while the header stays pinned —
  // resync on scroll (rAF-debounced) so the overlay tracks the moving bottom edge.
  let scrollScheduled = false;
  window.addEventListener('scroll', () => {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      scrollScheduled = false;
      sync();
    });
  }, { passive: true });

  // Recompute when the search form opens, in case anything has shifted
  document.querySelector('[data-search-toggle]')?.addEventListener('click', () => {
    requestAnimationFrame(sync);
  });
}

function bindCartPageDiscount() {
  const apply = document.querySelector('[data-cart-apply-discount]');
  const input = document.getElementById('CartDiscountCode');
  if (!apply || !input) return;
  const submit = () => {
    const code = (input.value || '').trim();
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
  };
  apply.addEventListener('click', submit);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    }
  });
}

/**
 * When a price filter is active on a collection page, the storefront filter
 * automatically excludes enquiry-only products (since their price is 0 or below
 * the user's minimum). This re-injects them so they remain discoverable
 * regardless of price range — they have no price to filter by.
 */
function injectEnquiryOnlyProducts() {
  const grid = document.querySelector('[data-products-grid][data-collection-handle]');
  if (!grid) return;
  const handle = grid.dataset.collectionHandle;
  const params = new URLSearchParams(location.search);
  const hasPriceFilter = params.has('filter.v.price.gte') || params.has('filter.v.price.lte');
  if (!hasPriceFilter) return;

  fetch(`/collections/${handle}/products.json?limit=250`, { credentials: 'same-origin' })
    .then((r) => r.ok ? r.json() : { products: [] })
    .then((data) => {
      const onPage = new Set(
        Array.from(grid.querySelectorAll('a[href*="/products/"]'))
          .map((a) => (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/)?.[1])
          .filter(Boolean)
      );
      const enquiryProducts = (data.products || []).filter((p) =>
        (p.tags || []).some((t) => t === 'enquire-now' || t === 'enquiry-only') &&
        !onPage.has(p.handle)
      );
      if (enquiryProducts.length === 0) return;
      const escape = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      enquiryProducts.forEach((p) => {
        const img = p.images?.[0]?.src || '';
        const title = escape(p.title);
        const li = document.createElement('li');
        li.className = 'product type-product product_tag-enquire-now enquiry-injected';
        li.innerHTML = `
          <div class="univercell-product">
            <figure>
              <a href="/products/${escape(p.handle)}" class="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                ${img ? `<img src="${escape(img)}" alt="${title}" loading="lazy">` : ''}
              </a>
            </figure>
            <figcaption>
              <h2 class="woocommerce-loop-product__title"><a href="/products/${escape(p.handle)}">${title}</a></h2>
              <button type="button" class="enquire-now-custom-btn-list" data-product="${title}" data-product-handle="${escape(p.handle)}">Enquire Now</button>
            </figcaption>
          </div>`;
        grid.appendChild(li);
      });
    })
    .catch(() => {});
}

/* Enquire Now Modal */
window.addEventListener('load', function() {
  const modal = document.getElementById('enquire-now-modal');
  if (!modal) return;

  const productField = modal.querySelector('#enquire-product');
  const handleField = modal.querySelector('#enquire-product-handle');
  const urlField = modal.querySelector('#enquire-page-url');
  const form = modal.querySelector('#enquire-now-form');

  const closeModal = () => {
    modal.style.display = 'none';
    if (form) form.reset();
  };

  document.addEventListener('click', function(e) {
    const target = e.target;
    const trigger = target.closest('.enquire-now-custom-btn, .enquire-now-custom-btn-list');
    if (trigger) {
      e.preventDefault();
      const productName = trigger.dataset.product || '';
      const productHandle = trigger.dataset.productHandle || '';
      if (productField) {
        productField.value = productName;
        productField.setAttribute('readonly', true);
      }
      if (handleField) handleField.value = productHandle;
      if (urlField) urlField.value = window.location.href;
      modal.style.display = 'flex';
      const emailField = modal.querySelector('#enquire-email');
      if (emailField) emailField.focus();
      return;
    }

    if (target.closest('.enquire-now-close')) {
      closeModal();
    }
  });

  window.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
  });

  // The form submits natively to Shopify's /contact (the {% form 'contact' %} tag
  // supplies the fields the endpoint requires; a fetch POST gets rejected). On
  // success Shopify redirects back with ?contact_posted=true and the snippet
  // renders its success block; on validation error it renders an error block.
  // Reopen the modal in either case so the user sees the result.
  if (modal.querySelector('[data-enquire-success], [data-enquire-error]')) {
    modal.style.display = 'flex';
  }
});
